import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type { AuditFilter, AuditLogPageDto } from './types';

export function useAudit(filter: AuditFilter) {
  return useQuery({
    queryKey: ['audit', filter],
    queryFn: async () => {
      const params: Record<string, string | number> = {
        page: filter.page,
        pageSize: filter.pageSize,
      };
      if (filter.from) params['from'] = filter.from;
      if (filter.to) params['to'] = filter.to;
      if (filter.action != null) params['action'] = filter.action;
      if (filter.entityType) params['entityType'] = filter.entityType;
      return (await apiClient.get<AuditLogPageDto>('/api/audit', { params })).data;
    },
    placeholderData: keepPreviousData,
  });
}
